import React from 'react';
import '../styles/UserList.css';

const RoleTabs = ({ value, onChange, counts }) => {
  const { all = 0, owners = 0, employees = 0, clients = 0 } = counts || {};
  const tabs = [
    { key: 'all', label: 'All', count: all },
    { key: 'owners', label: 'Owners', count: owners },
    { key: 'employees', label: 'Employees', count: employees },
    { key: 'clients', label: 'Clients', count: clients }
  ];

  return (
    <div className="userListSeg" role="tablist" aria-label="User categories">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className="userListSegBtn"
          aria-pressed={value === t.key ? 'true' : 'false'}
          onClick={() => onChange(t.key)}
        >
          <span>{t.label}</span>
          <span className="userListCount" aria-label={`${t.count} ${t.label}`}>
            {t.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default RoleTabs;


